import {
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Table,
  TableActionBarRow,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGetLogsById } from "../../hooks/logs/useGetLogsById";
import { Search } from "../search/Search";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { findInTable } from "../../helper/commonHelper";
import { isEmpty } from "lodash-es";
import {
  TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry,
  TrackingTrackingModelsLegacyLogEntry,
} from "melco-shared-logic";
import { format } from "date-fns";
import JSONPretty from "react-json-pretty";

const { spacings } = DesignTokens;

const StyledWrapperTable = styled.div`
  table td {
    vertical-align: top;
  }
`;

const StyledWrapperRow = styled(Row)`
  padding: ${spacings.xlarge}px ${spacings.xlarge}px ${spacings.xlarge}px
    ${spacings.xlarge}px;
`;

export const LogsList: React.FC = () => {
  // Display data columns
  const [displayData, setDisplayData] = useState<
    TrackingTrackingModelsLegacyLogEntry[]
  >([]);
  // All data coming in allResponse
  const [allResponseData, setAllResponseData] =
    useState<TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry>();
  // Specific fields data that coming in response and we have to display in table
  const [specificResponseData, setSpecificResponseData] = useState<
    Array<TrackingTrackingModelsLegacyLogEntry>
  >([]);
  // value in search , that we will look at local end only
  const [searchValue, setSearchValue] = useState<string>();
  // one object that we take from original allResponse , to display the common data in UI
  // basically it is data that is repeating in every record like country, city etc.
  // But here we will taking very first object of allResponse that may have data that is not repeating like servity_code, properties, message
  // then we will use required data that we want to display common data
  const [firstObjToDisplayCommonData, setFirstObjToDisplayCommonData] =
    useState<TrackingTrackingModelsLegacyLogEntry>();

  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    searchQueryChange,
    searchQuery,
  } = useGetLogsById();

  const { t } = useTranslation();

  useEffect(() => {
    //  setDisplayData(data);
    let specificData = data?.list?.map(
      (d: TrackingTrackingModelsLegacyLogEntry) => {
        return {
          properties: d.properties,
          severity_level: d.severity_level,
          message: d.message,
          time_generated: d.time_generated
            ? format(d?.time_generated, "MM/dd/yyyy, hh:mm:ss.SSS aa ")
            : "",
        };
      }
    );
    setSpecificResponseData(specificData);
    setAllResponseData(data);
  }, [data]);

  useEffect(() => {
    console.log(searchValue);
    setFirstObjToDisplayCommonData(allResponseData?.list?.[0]);
    searchLocal(searchValue ?? "");
  }, [specificResponseData, allResponseData, searchValue]);

  const columns = [
    {
      title: t("logs.table.columns.severity_level"),
      key: "severity_level",
      dataIndex: "severity_level",
      width: 140,
    },
    {
      title: t("logs.table.columns.time"),
      width: 140,

      render: (rowObj: TrackingTrackingModelsLegacyLogEntry) => {
        return <>{rowObj?.time_generated}</>;
      },
    },
    {
      title: t("logs.table.columns.message"),
      key: "message",

      dataIndex: "message",
    },
    {
      title: t("logs.table.columns.properties"),
      // key: "properties",
      // dataIndex: "properties",

      render: (rowObj: TrackingTrackingModelsLegacyLogEntry) => {
        return (
          <>
            <JSONPretty
              id="json-pretty"
              data={JSON.parse(rowObj?.properties ?? "")}
            ></JSONPretty>
          </>
        );
      },
    },
  ];

  const searchLocal = (value: string) => {
    if (!isEmpty(value)) {
      let filteredData = findInTable(specificResponseData, value);
      setDisplayData(filteredData);
    } else {
      setDisplayData(specificResponseData);
    }
  };

  return (
    <>
      <TableActionBarRow>
        <Col xs={24} xl={17}>
          <Row gutter={[spacings.middle, spacings.middle]}>
            <Col flex={0}>
              <Search
                placeholder={t("logs.label.trace_id")}
                onSearchInputChange={searchQueryChange}
              />
            </Col>
            {searchQuery && (
              <Col flex={0}>
                <Search
                  onSearchInputChange={(query: string) => {
                    setSearchValue(query);
                  }}
                />
              </Col>
            )}
          </Row>
        </Col>
      </TableActionBarRow>
      <StyledWrapperRow>
        <FullWidthSpace direction="vertical" size="small">
          <Row gutter={[spacings.middle, spacings.middle]}>
            <Col xs={24} md={6} xl={6}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("logs.label.app_role_instance")}
                  content={firstObjToDisplayCommonData?.app_role_instance ?? ""}
                  fallback={t("global.fallback.empty")}
                />
                <LabeledItem
                  label={t("logs.label.client_type")}
                  content={firstObjToDisplayCommonData?.client_type ?? ""}
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
            <Col xs={24} md={6} xl={6}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("logs.label.city")}
                  content={firstObjToDisplayCommonData?.client_city ?? ""}
                  fallback={t("global.fallback.empty")}
                />
                <LabeledItem
                  label={t("logs.label.country")}
                  content={
                    firstObjToDisplayCommonData?.client_country_or_region ?? ""
                  }
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
            <Col xs={24} md={6} xl={6}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("logs.label.state")}
                  content={
                    firstObjToDisplayCommonData?.client_state_or_province ?? ""
                  }
                  fallback={t("global.fallback.empty")}
                />
              </Space>
            </Col>
            <Col xs={24} md={6} xl={6}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("logs.label.ip")}
                  content={firstObjToDisplayCommonData?.client_ip ?? ""}
                  fallback={t("global.fallback.empty")}
                />
                {/* <LabeledItem
                  label={t('logs.label.time')}
                  content={firstObjToDisplayCommonData?.time_generated ? new Date(firstObjToDisplayCommonData.time_generated).toLocaleString() + '    XXXXXXX    ' + firstObjToDisplayCommonData.time_generated + '  XXXXXX  ' + format((firstObjToDisplayCommonData.time_generated), "yyyy-MM-dd HH:mm:ss:SSS aa") : ""}
                  fallback={t('global.fallback.empty')} />
                <LabeledItem
                  label={t('logs.label.type')}
                  content={firstObjToDisplayCommonData?.type ?? ""}
                  fallback={t('global.fallback.empty')} /> */}
              </Space>
            </Col>
          </Row>
        </FullWidthSpace>
      </StyledWrapperRow>
      <StyledWrapperTable>
        <Table
          showSorterTooltip={false}
          sticky
          loading={isPreviousData ? isFetching : isLoading}
          dataSource={displayData}
          columns={columns}
          pagination={false}
          noDataMessage={t("logs.table.no_logs_message")}
          errorComponent={errorComponent}
        />
      </StyledWrapperTable>
    </>
  );
};
